var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "fc-introduce" }, [
    _c("h4", { staticClass: "fc-introduce__title" }, [_vm._v("수강 대상")]),
    _vm._v(" "),
    _c("h6", { staticClass: "fc-introduce__sub-title" }, [
      _vm._v("이런 분들께 추천 드려요!"),
    ]),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "fc-introduce__cards" },
      _vm._l(_vm.cards, function (ref) {
        var icon = ref.icon
        var title = ref.title
        return _c("li", { key: title, staticClass: "fc-introduce__card" }, [
          _c("figure", { staticClass: "fc-introduce__icon" }, [
            _c("img", { attrs: { src: icon, alt: title } }),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "fc-introduce__desc" }, [
            _vm._v(_vm._s(title)),
          ]),
        ])
      }),
      0
    ),
    _vm._v(" "),
    _c("h4", { staticClass: "fc-introduce__title" }, [
      _vm._v("강의 수강을 위한 사전지식"),
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "fc-introduce__sub-title" }, [
      _vm._v("이 정도 준비가 되어있다면, 강의 들을 준비 끝!"),
    ]),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "fc-introduce__wrapper" },
      _vm._l(_vm.descriptions, function (desc, i) {
        return _c("li", {
          key: i,
          staticClass: "fc-introduce__text",
          domProps: { innerHTML: _vm._s(desc) },
        })
      }),
      0
    ),
    _vm._v(" "),
    _c("h4", { staticClass: "fc-introduce__title" }, [_vm._v("학습 목표")]),
    _vm._v(" "),
    _c("p", { staticClass: "fc-introduce__sub-title" }, [
      _vm._v("석사 졸업생도 놀랄, 수강 후 당신의 모습!"),
    ]),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "fc-introduce__wrapper" },
      _vm._l(_vm.goals, function (desc, i) {
        return _c("li", {
          key: i,
          staticClass: "fc-introduce__text",
          domProps: { innerHTML: _vm._s(desc) },
        })
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }